import { DuplexerEvent, ScanFailureReason } from '@wix/a11y-wizard-common';
import { useExperiments } from '@wix/fe-essentials/react';
import { useMemo } from 'react';
import { SITE_LEVEL_PAGE_ID } from '../consts';
import { AnalysisState, usePanelStateAtom } from '../hooks/rules-state';
import { useScanTimeoutManager } from '../hooks/scan-timeout';
import { isStaticPage } from '../rule-mappers/shared/helpers';
const shouldRetainFailureReason = (addErrorModals, failureReason) => addErrorModals || failureReason === ScanFailureReason.PAGE_ACCESS_DENIED;
export const useGetDuplexerEventHandlers = () => {
  const {
    setGroupAnalysisData,
    setGroupData,
    setGroupsAnalysisState,
    incrementFailedPagesTpa,
    getGroupData
  } = usePanelStateAtom();
  const {
    clearScanTimeoutsForItemType,
    clearPageScanTimeout
  } = useScanTimeoutManager();
  const {
    experiments
  } = useExperiments();
  const addErrorModals = experiments.enabled('specs.a11y.addErrorModals');
  const duplexerEventHandlers = useMemo(() => ({
    [DuplexerEvent.AnalyzePageCompleted]: payload => {
      var _getGroupData;
      const {
        pageId
      } = payload;
      const pagesDataItemType = (_getGroupData = getGroupData(pageId)) == null ? void 0 : _getGroupData.itemType;
      if (!isStaticPage(pagesDataItemType)) {
        setGroupAnalysisData({
          data: payload,
          itemType: pagesDataItemType
        });
      } else {
        setGroupAnalysisData({
          data: payload,
          pageId
        });
      }
      clearPageScanTimeout(pageId);
    },
    [DuplexerEvent.AnalyzePageFailed]: payload => {
      const {
        pageId,
        itemType
      } = payload;
      setGroupData(pageId, {
        analysisState: AnalysisState.AnalyzeFailed,
        ...(shouldRetainFailureReason(addErrorModals, payload.failureReason) ? {
          failureReason: payload.failureReason
        } : {})
      });
      if (!isStaticPage(itemType)) {
        incrementFailedPagesTpa(itemType);
      }
      clearPageScanTimeout(pageId);
    },
    [DuplexerEvent.AnalyzeSiteLevelCompleted]: payload => {
      setGroupAnalysisData({
        data: payload,
        pageId: SITE_LEVEL_PAGE_ID
      });
      clearPageScanTimeout(SITE_LEVEL_PAGE_ID);
    },
    [DuplexerEvent.AnalyzeSiteLevelFailed]: payload => {
      setGroupData(SITE_LEVEL_PAGE_ID, {
        analysisState: AnalysisState.AnalyzeFailed,
        ...(shouldRetainFailureReason(addErrorModals, payload.failureReason) ? {
          failureReason: payload.failureReason
        } : {})
      });
      clearPageScanTimeout(SITE_LEVEL_PAGE_ID);
    },
    [DuplexerEvent.AnalyzeJobCompleted]: payload => {
      const {
        type
      } = payload;
      if (!isStaticPage(type)) {
        setGroupAnalysisData({
          data: payload,
          isJobCompleted: true,
          itemType: type
        });
      }
    },
    [DuplexerEvent.AnalyzeJobFailed]: payload => {
      const {
        type: itemType
      } = payload;
      clearScanTimeoutsForItemType(itemType);
      if (shouldRetainFailureReason(addErrorModals, payload.failureReason)) {
        setGroupsAnalysisState(AnalysisState.AnalyzeFailed, itemType, false, payload.failureReason);
      } else {
        setGroupsAnalysisState(AnalysisState.AnalyzeFailed, itemType);
      }
    }
  }), [addErrorModals, getGroupData, setGroupAnalysisData, clearPageScanTimeout, setGroupData, incrementFailedPagesTpa, clearScanTimeoutsForItemType, setGroupsAnalysisState]);
  return duplexerEventHandlers;
};
//# sourceMappingURL=use-get-duplexer-event-handlers.js.map